import QuantityCounter from "../common/quantityCounter";
import NavBar from "../components/navBar";
import { useState, useEffect, useContext } from "react";
import Button from "../common/button";
import CrossIcon from "../icons/crossIcons";
import cities from "../cities.json";
import TextField from "../common/textField";
import RadioButton from "../common/radioButton";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { UserContext } from "../context/userContext";
import httpServices from "../auth/httpServices";

const coupons = [
  { id: 1, phrase: "dis15", discount: 0.15 },
  { id: 2, phrase: "dis10", discount: 0.1 },
];

function Cart() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const [appliedCoupon, setAppliedCoupon] = useState({
    isApplied: false,
    isValid: true,
  });
  const [inputErrors, setInputError] = useState({
    firstName: { isValid: true, message: "First name is empty" },
    lastName: { isValid: true, message: "Last name is empty" },
    address: { isValid: true, message: "Address is empty" },
    phone: { isValid: true, message: "Phone is empty " },
    email: { isValid: true, message: "Email is empty" },
    city: { isValid: true, message: "City is empty" },
    postalCode: { isValid: true, message: "Postalcode is empty" },
    pickupLocation: { isValid: true, message: "Pickup location not selected" },
  });

  const [phoneIsValid, setPhoneIsValid] = useState(true);

  const [order, setOrder] = useState({
    products: [],
    subTotal: 0,
    tax: 0,
    discountAmount: 0,
    discountCode: "",
    grandTotal: 0,
    shippingInfo: {
      firstName: "",
      lastName: "",
      address: "",
      email: "",
      phone: 0,
      city: "",
      postalCode: "",
      pickupLocation: "",
    },
    userId: "",
  });

  console.log(order);

  const sortedItems = order.products.sort((a, b) => {
    return a._id - b._id;
  });

  const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  !cartItems.length && (
    <p className="warning-message">Please add some products!</p>
  );

  const itemsTotal = sortedItems.map((item) => item.price * item.quantity);
  const subTotal = itemsTotal.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  const tax = +(subTotal * 0.15).toFixed(2);

  useEffect(() => {
    // console.log(userContext._id);
    setOrder({
      ...order,
      products: cartItems,
      // userId: userContext._id,
    });

    if (tax && subTotal && !order.discountCode) {
      setOrder({ ...order, grandTotal: subTotal + tax, tax, subTotal });
    } else if (order.discountCode) {
      const coupon = coupons.find(
        (coupon) => coupon.phrase === order.discountCode.toLowerCase()
      );
      if (coupon) {
        const discount = (subTotal + tax) * coupon.discount;
        setOrder({
          ...order,
          grandTotal: +(subTotal + tax - discount).toFixed(2),
          discountAmount: +discount.toFixed(2),
        });
      }
    }
  }, [subTotal, userContext]);

  function handleIncrement(e, quantity) {
    const { id } = e.target;
    const editedItem = sortedItems.map((item) => {
      if (item._id === id) {
        return { ...item, quantity: quantity };
      } else {
        return item;
      }
    });
    // setItems(editedItem);
    setOrder({ ...order, products: editedItem });
  }

  function handleDecrement(e, quantity) {
    const { id } = e.target;
    const editedItem = sortedItems.map((item) => {
      if (item._id === id) {
        return { ...item, quantity: quantity };
      } else {
        return item;
      }
    });
    // setItems(editedItem);
    setOrder({ ...order, products: editedItem });
    localStorage.setItem("cartItems", JSON.stringify(editedItem));
  }

  function handleDelete(e) {
    const { id } = e.target;
    const filterItems = sortedItems.filter(
      (item) => String(`${item._id}${item.selectedSize}`) !== id
    );
    // setItems(filterItems);
    setOrder({ ...order, products: filterItems });
    localStorage.setItem("cartItems", JSON.stringify(filterItems));
  }

  function handleCouponInputChange(e) {
    setOrder({ ...order, discountCode: e.target.value });
    setAppliedCoupon({
      isApplied: false,
      isValid: true,
    });
    if (!e.target.value) {
      setOrder({ ...order, grandTotal: subTotal + tax, discountAmount: 0 });
    }
  }

  function handleApplyButton(e) {
    const coupon = coupons.find(
      (coupon) => coupon.phrase === order.discountCode.toLowerCase()
    );
    if (coupon && !appliedCoupon.isApplied && !order.discountAmount) {
      const discount = order.grandTotal * coupon.discount;
      setAppliedCoupon({ ...appliedCoupon, isApplied: true });
      setOrder({
        ...order,
        grandTotal: +(order.grandTotal - discount).toFixed(2),
        discountAmount: Number(discount.toFixed(2)),
      });
    } else if (!coupon) {
      setAppliedCoupon({ isValid: false, isApplied: true });
    } else if (coupon && !appliedCoupon.isApplied && order.discountAmount) {
      const discount = (subTotal + tax) * coupon.discount;
      setAppliedCoupon({ ...appliedCoupon, isApplied: true });
      setOrder({
        ...order,
        grandTotal: (subTotal + tax - discount).toFixed(2),
        discountAmount: Number(discount.toFixed(2)),
      });
    }

    if (coupon) {
      const discount = (subTotal + tax) * coupon.discount;
      setOrder({
        ...order,
        discountAmount: Number(discount.toFixed(2)),
        grandTotal: +(subTotal + tax - discount).toFixed(2),
      });
    } else {
      setOrder({ ...order, discountAmount: 0, grandTotal: subTotal + tax });
    }
  }

  function handleTextField(e) {
    const { value, name } = e.target;

    if (name === "phone") {
      if (!validator.isMobilePhone(value)) {
        setPhoneIsValid(false);
      } else {
        setPhoneIsValid(true);
      }
    }
    setOrder({
      ...order,
      shippingInfo: { ...order.shippingInfo, [name]: value },
    });

    setInputError({
      ...inputErrors,
      [name]: {
        ...inputErrors[name],
        isValid: true,
      },
    });
  }

  function handleCheckout(e) {
    if (
      order.shippingInfo.firstName &&
      order.shippingInfo.lastName &&
      order.shippingInfo.address &&
      order.shippingInfo.phone &&
      order.shippingInfo.email &&
      order.shippingInfo.city &&
      order.shippingInfo.postalCode &&
      order.shippingInfo.pickupLocation
    ) {
      httpServices
        .post("http://localhost:5000/order", order)
        .then((results) => {
          console.log(results);
          // console.log(results.data);
          navigate(`/thankyou/${results.data.orderId}`);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setInputError({
        firstName: {
          ...inputErrors.firstName,
          isValid: !order.shippingInfo.firstName ? false : true,
        },
        lastName: {
          ...inputErrors.lastName,
          isValid: !order.shippingInfo.lastName ? false : true,
        },
        address: {
          ...inputErrors.address,
          isValid: !order.shippingInfo.address ? false : true,
        },
        phone: {
          ...inputErrors.phone,
          isValid: !order.shippingInfo.phone ? false : true,
        },
        email: {
          ...inputErrors.email,
          isValid: !order.shippingInfo.email ? false : true,
        },
        city: {
          ...inputErrors.city,
          isValid: !order.shippingInfo.city ? false : true,
        },
        postalCode: {
          ...inputErrors.postalCode,
          isValid: !order.shippingInfo.postalCode ? false : true,
        },
        pickupLocation: {
          ...inputErrors.pickupLocation,
          isValid: !order.shippingInfo.pickupLocation ? false : true,
        },
      });
    }
  }

  return (
    <div>
      <NavBar />
      <div className="cart-title">
        <h2>SHOPPING CART</h2>
      </div>
      <div className="cart-product-container">
        <table className="cart-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {sortedItems.map((item) => {
              return (
                <tr key={`${item._id}${item.selectedSize}`}>
                  <td>
                    <img src={item.image} alt="wow" />
                    <p>{item.name}</p>
                    <div className="size-badge-container">
                      <p className="size-badge">
                        {item.selectedSize.toUpperCase()}
                      </p>
                    </div>
                  </td>
                  <td>Rs. {item.price}</td>
                  <td>
                    <QuantityCounter
                      className="cart-quantity-counter"
                      onIncrement={handleIncrement}
                      onDecrement={handleDecrement}
                      id={item._id}
                      defaultQuantity={item.quantity}
                    />
                  </td>
                  <td>
                    Rs.{" "}
                    {item.quantity ? item.price * item.quantity : item.price}
                  </td>
                  <td className="delete-cross">
                    <div className="delete-icon-container">
                      <CrossIcon size={15} />
                      <div
                        className="delete-icon-layer"
                        onClick={handleDelete}
                        id={`${item._id}${item.selectedSize}`}
                      ></div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="warning-message-container">
          {!cartItems.length && (
            <p className="warning-message">PLEASE ADD SOME PRODUCTS!</p>
          )}
        </div>
        <div className="coupon-container">
          <div className="coupon">
            <div className="coupon-wrapper">
              <label htmlFor="coupon">Coupon: </label>
              <TextField
                type="text"
                name="coupon"
                id="coupon"
                onChange={handleCouponInputChange}
              />
              <Button onClick={handleApplyButton} className="apply-button">
                Apply
              </Button>
            </div>
            <div>
              {!appliedCoupon.isValid && (
                <p className="warning-message">wrong coupon code!</p>
              )}
            </div>
          </div>
        </div>
        <div className="cart-total">
          <div className="sub-total">
            <h4>Sub Total</h4>
            <p>Rs.{subTotal}</p>
          </div>
          <div className="tax">
            <h4>Tax</h4>
            <p>Rs.{tax}</p>
          </div>
          {appliedCoupon.isApplied && appliedCoupon.isValid && (
            <div className="discount">
              <h4>Discount</h4>
              <p>Rs. {order.discountAmount}</p>
            </div>
          )}
          <div className="total">
            <h4>Grand Total</h4>
            <p>Rs. {order.grandTotal}</p>
          </div>
        </div>
      </div>
      <div className="shipping-information-container">
        <div className="shipping-title">
          <h2>SHIPPING INFORMATION</h2>
        </div>
        <form className="shipping-information">
          <div className="inputs-name-wrapper">
            <TextField
              placeholder="First Name"
              className="input-field"
              onChange={handleTextField}
              name="firstName"
              containerClassName="input-container"
              errorMessage={inputErrors.firstName.message}
              isValid={inputErrors.firstName.isValid}
            />
            <TextField
              placeholder="Last Name"
              className="input-field"
              onChange={handleTextField}
              name="lastName"
              containerClassName="input-container"
              errorMessage={inputErrors.lastName.message}
              isValid={inputErrors.lastName.isValid}
            />
            <TextField
              placeholder="Address"
              className="input-field"
              onChange={handleTextField}
              name="address"
              containerClassName="input-container"
              errorMessage={inputErrors.address.message}
              isValid={inputErrors.address.isValid}
            />
            <TextField
              placeholder="Phone"
              className="input-field"
              onChange={handleTextField}
              name="phone"
              containerClassName="input-container"
              errorMessage={inputErrors.phone.message}
              isValid={inputErrors.phone.isValid}
            />
            <p className="warning-message">
              {!phoneIsValid && "phone number is not valid!"}
            </p>
            <TextField
              placeholder="Email"
              className="input-field"
              onChange={handleTextField}
              name="email"
              containerClassName="input-container"
              errorMessage={inputErrors.email.message}
              isValid={inputErrors.email.isValid}
            />
            <div className="select-container">
              <select
                className="first-option"
                name="city"
                onChange={handleTextField}
              >
                <option value="" disabled hidden>
                  City
                </option>
                {cities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {!inputErrors.city.isValid && (
                <label className="textfield-error">
                  {inputErrors.city.message}
                </label>
              )}
            </div>
            <TextField
              placeholder="Postal Code "
              className="input-field"
              onChange={handleTextField}
              name="postalCode"
              containerClassName="input-container"
              errorMessage={inputErrors.postalCode.message}
              isValid={inputErrors.postalCode.isValid}
            />
          </div>
        </form>
      </div>
      <div className="pickups-buttons">
        <h4>Please choose a pickup location:</h4>
        <form className="pickups-options" onChange={handleTextField}>
          <RadioButton
            name="pickupLocation"
            id="pickup"
            label="Store pickup"
            value="pickup"
          />
          <RadioButton
            name="pickupLocation"
            id="delivery"
            label="Delivery"
            value="delivery"
          />
        </form>
        <div className="error-label-container">
          {!inputErrors.pickupLocation.isValid && (
            <label className="textfield-error">
              {inputErrors.pickupLocation.message}
            </label>
          )}
        </div>
      </div>

      <div className="checkout-button-container">
        <Button className="checkout-button" onClick={handleCheckout}>
          Checkout
        </Button>
      </div>
    </div>
  );
}

export default Cart;
